<h1 mat-dialog-title>Confirm spACE Email Address</h1>
<div mat-dialog-content>
    <p>You are about to send the email link to the customer. Ensure the email address you are entering is correct and accurate.</p>
    <p style="margin-top:15px;font-size:16px;">Email Address: <strong>{{emailAddress}}</strong></p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Submit</button>
</div>
